import { render, staticRenderFns } from "./ChangeLogEntry.vue?vue&type=template&id=555ef182"
import script from "./ChangeLogEntry.vue?vue&type=script&lang=js"
export * from "./ChangeLogEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports